<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="16">
            <el-input placeholder="输入船员信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>

          <el-col :span="8">
            &nbsp;&nbsp;
            <el-button type="primary" size="small"  @click="handleCreate">新增船员</el-button>
          </el-col>
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100" @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <!-- 客户名称 -->
            <el-table-column align="left" label="船员名称" min-width="120px">
              <template slot-scope="scope">
                <span v-if="$perm(['crew.view_crew'])" class="font-weight-bold text-link"
                      @click="handleView(scope.row)">{{scope.row.name}}</span>
                <span v-else class="font-weight-bold">{{scope.row.name}}</span>
                <span class="badge ml-2" :class="scope.row.type === '0' ? 'badge-success' : 'badge-warning'">{{ scope.row.type_name }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="手机号">
              <template slot-scope="scope">
                <span>{{scope.row.mobile}}</span>
              </template>
            </el-table-column>
       
            <!-- 更新人 -->
            <el-table-column align="left" label="创建人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>
            <!-- 申请时间 -->
            <el-table-column align="left" label="申请时间">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="操作">
              <template slot-scope="scope">

                <el-tooltip effect="light" placement="top-start" content="查看">
                    <el-button type="text" @click="handleView(scope.row)" ><i class="el-icon-view"></i></el-button>
                </el-tooltip>

                <el-tooltip effect="light" placement="top-start" content="编辑">
                    <el-button type="text" @click="handleUpdate(scope.row)" ><i class="el-icon-edit"></i></el-button>
                </el-tooltip>

                
                <el-tooltip effect="light" content="上传" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                    <i class="el-icon-upload"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                  <el-button v-if="$perm(['crew.delete_crew'])"
                             type="text" @click="handleDelete(scope.row)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>

              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
          <upload-dialog ref="upload"
              :object-name="object_name"
              :file-type-list="file_type_list"
              object-type="crew.crew"
              :object-id="apply_id"
              :ship-list="shipList" 
              :customer-list="customerList"
              :is-upload="true"
              @uploaded="handleAppended">
          </upload-dialog>
        </div>
      </el-card>
      <make-document-dialog ref="makeDocument"
                            :command_list="command_list"
                            :data="multipleSelection">
      </make-document-dialog>
    </div>
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import {getCrewList,deleteCrew} from '@/api/crew'
    import UploadDialog from "@/components/UploadDialog"
    import { fetchFileTypeList } from "@/api/common"
    import MakeDocumentDialog from '@/views/ib/group-insurance/make-document-dialog'
  
    export default {
      name: "crewList",
      components: {
        PaginationNew,
        UploadDialog,
        MakeDocumentDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          query: {
            search: '',
            offset: 0,
            limit: 20
          },
          apply_id:"",
          object_name:"",
          searching: false,
          dialogVisible:false,
          customerList:[],
          shipList:[],
          groupList:[],
          file_type_list:[],
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          list: [],
          total: 0,
       
          command_list: ['three'],
          multipleSelection: []
        }
      },
      methods: {

        
        handleDelete(row){
            this.$confirm('是否删除该船员', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                deleteCrew({id:row.id}).then(res => {
                this.$message({type: 'success', message: '删除成功!'})
                this.getList()
            }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
          
        },
        handleView(row){
            this.setQueryStorage()
            this.$router.push({ name: 'crewDetail', query: {'type': 'View', 'id': row.id}})
        },
        handleUpdate(row){
            this.setQueryStorage()
            this.$router.push({ name: 'crewDetail', query: {'type': 'Update', 'id': row.id}})
        },
        handleCreate(){
            this.setQueryStorage()
            this.$router.push({ name: 'crewDetail', query: {'type': 'Create'}})
        },
        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        handleUpload(row) {
          this.apply_id = row.id
          this.object_name = row.name
          this.$refs.upload.handleOpen()
        },
     
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        handleSearch() {
          this.getList()
        },
        getList() {
          // 从数据库中加载用户数据
          this.listLoading = true
          getCrewList(this.query)
            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
              this.$emit("toIndex", res.count)
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
        loadData() {
          this.loading = true
          let p = []
          p.push(fetchFileTypeList({file_type: "bc|sc|cc"}))

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
      
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },

      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20
            
          }
        this.loadData()
        this.getList()
      }
    }
  </script>
  